import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'core_modules/aexp-lazyload';
import Placeholder from './placeholder';

const LazyLoadImage = ({
  img = null,
  height = '100%',
  once = true,
  offset = 200,
  overflow = false,
  placeholder = <Placeholder />
}) => (
  <LazyLoad
    height={height}
    once={once}
    offset={offset}
    placeholder={placeholder}
    overflow={overflow}
  >
    {img}
  </LazyLoad>
);

LazyLoadImage.propTypes = {
  img: PropTypes.element.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  once: PropTypes.bool,
  overflow: PropTypes.bool,
  placeholder: PropTypes.element
};

export default LazyLoadImage;
